class PreorderDisclaimer extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.input?.addEventListener('change', this.handleChange.bind(this));
    this.buyButton = this.parentElement.querySelector('.product-form__buttons');
  }

  isChecked() {
    return this.input.checked;
  }

  handleChange() {
    if (!this.buyButton) return;
    if (!this.isChecked()) {
      this.buyButton.querySelector('button[type="submit"]').setAttribute('disabled', true);
    } else {
      this.buyButton.querySelector('button[type="submit"]').removeAttribute('disabled');
    }
  }
}

customElements.define('preorder-disclaimer', PreorderDisclaimer);
